module.exports = __webpack_public_path__ + "static/media/icon_csv_green.76f343b5.svg";